import Constants from '../Constants.js';
import BlueprintReducer from './BlueprintReducer.js';
const {
  getStatus,
  getError,
  getBlueprints
} = BlueprintReducer;
class Blueprints {
  constructor(projectId) {
    this.projectId = projectId;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      const projectId = this.projectId || opts && opts.api && opts.api.projectId;
      dispatch({
        type: Constants.BLUEPRINT_STATUS,
        status,
        projectId
      });
      return func(dispatch, getState, opts, projectId).catch(error => {
        dispatch({
          type: Constants.BLUEPRINT_STATUS,
          projectId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  list(opts = {}) {
    return this.createAction('list', 'loading', async (dispatch, getState, {
      api
    }, projectId) => {
      const r = await api.project(projectId).blueprints().list({
        children: ['attribute'],
        attribute: {
          perPage: 10000
        },
        perPage: 1000,
        ...opts
      });
      // assuming all
      dispatch({
        type: Constants.BLUEPRINT_LIST,
        projectId,
        items: r.items
      });
      return r;
    });
  }

  // State accessors 
  getStatus(state) {
    return getStatus(state, this.projectId);
  }
  getError(state) {
    return getError(state, this.projectId);
  }
  getBlueprints(state) {
    return getBlueprints(state, this.projectId);
  }
}
export default Blueprints;